import {
  LayoutDashboard,
  BookOpen,
  FileText,
  DollarSign,
  User,
  LogOut,
  Upload,
  CalendarDays,
  BarChart,
  Users,
  ClipboardCheck,
  Layers,
  FilePlus,
  MessageCircle,
} from "lucide-react";

export const MENUITEMS = [
  {
    menutitle: "Main Menu",
    menucontent: "Common access items",
    Items: [
      {
        path: "/dashboard",
        icon: LayoutDashboard,
        title: "Dashboard",
        type: "link",
      },
      {
        path: "/courses",
        icon: BookOpen,
        title: "Courses",
        type: "link",
      },
      {
        path: "/ebooks",
        icon: FileText,
        title: "Ebooks",
        type: "link",
      },
      {
        path: "/transactions",
        icon: DollarSign,
        title: "Transactions",
        type: "link",
      },
      {
        path: "/profile",
        icon: User,
        title: "Profile",
        type: "link",
      },
      {
        path: "/subscriptions",
        icon: MessageCircle,
        title: "Subscriptions",
        type: "link",
      },
    ],
  },
  {
    menutitle: "Admin Panel",
    menucontent: "Only for admin users",
    Items: [
      {
        title: "Upload",
        icon: Upload,
        type: "sub",
        permission: "admin", // used to filter later
        children: [
          {
            title: "Upload Ebooks",
            path: "/uploadEbooks",
            type: "link",
            permission: "admin",
          },
          {
            title: "Upload Videos",
            path: "/uploadVideos",
            type: "link",
            permission: "admin",
          },
          {
            title: "Upload Courses",
            path: "/uploadCourses",
            type: "link",
            permission: "admin",
          },
        ],
      },
      {
        title: "Admin",
        icon: Layers,
        type: "sub",
        permission: "admin",
        children: [
          {
            title: "Schedule",
            path: "/admin/schedule",
            type: "link",
            permission: "admin",
          },
           {
            title: "Schedule Classes",
            path: "/schedule",
            type: "link",
            permission: "admin",
          },
          {
            title: "Registration",
            path: "/admin/registration",
            type: "link",
            permission: "admin",
          },
          // {
          //   title: "Attendance",
          //   path: "/attendance",
          //   type: "link",
          //   permission: "admin",
          // },
          {
            title: "Coach Assignment",
            path: "/admin/coach",
            type: "link",
            permission: "admin",
          },
          {
            title: "Session Tracker",
            path: "/admin/session",
            type: "link",
            permission: "admin",
          },
          {
            title: "Revenue Report",
            path: "/admin/revenue",
            type: "link",
            permission: "admin",
          },
          {
            title: "Monthly Report",
            path: "/admin/monthly-report",
            type: "link",
            permission: "admin",
          },
          {
            title: "Subscription Forum",
            path: "/admin/subscriptions",
            type: "link",
            permission: "admin",
          },
        ],
      },
      {
        path: "/",
        icon: LogOut,
        title: "Logout",
        type: "link",
      },
    ],
  },
];
